(function () {
  'use strict';
  function init(root) {
    if (root.dataset.rcInit === '1') return;
    root.dataset.rcInit = '1';
    var track = root.querySelector('[data-relcats-track]');
    var prev = root.querySelector('[data-relcats-prev]');
    var next = root.querySelector('[data-relcats-next]');
    if (!track) return;
    function update() {
      var max = track.scrollWidth - track.clientWidth - 1;
      var overflow = max > 2;
      if (prev) prev.hidden = !overflow || track.scrollLeft <= 2;
      if (next) next.hidden = !overflow || track.scrollLeft >= max;
    }
    function step(d) { track.scrollBy({ left: d * track.clientWidth * 0.8, behavior: 'smooth' }); }
    if (next) next.addEventListener('click', function () { step(1); });
    if (prev) prev.addEventListener('click', function () { step(-1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    window.addEventListener('load', update);
    setTimeout(update, 400);
  }
  function all() { document.querySelectorAll('[data-relcats]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', function (e) { var el = e.target.querySelector('[data-relcats]'); if (el) init(el); });
})();
